import gql from 'graphql-tag';
import apollo from '../apollo';

const REMOVE_SURVEY_MUTATION = gql`
  mutation($input: DeleteSurveyInput!) {
    deleteSurvey(input: $input) {
      surveyId
    }
  }
`;

export const removeSurvey = input => apollo
  .mutate({
    mutation: REMOVE_SURVEY_MUTATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const ACTIVE_SURVEY_PROJECT_DEFINITION = gql`
  mutation activeSurveyProject($input: ActivateSurveyProjectInput!) {
    activateSurveyProject(input: $input) {
      id
      surveyImports {
        id
        status
      }
    }
  }
`;

export const activateSurveyImport = input => apollo
  .mutate({
    mutation: ACTIVE_SURVEY_PROJECT_DEFINITION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const SEND_SURVEY_PROJECT_EMAIL_INVITE = gql`
  mutation sendSurveyProjectEmailInvitations($input: SurveyProjectGenericMutationInput!) {
    sendSurveyProjectEmailInvitations(input: $input)
  }
`;
const UPDATE_SURVEY_CORE = gql`
  mutation($input: UpdateSurveyInput!) {
    updateSurvey(input: $input) {
      clientMutationId
      survey {
        id
        name
        tags
        commentsEnabled
      }
    }
  }
`;

export const updateSurveyCore = input => apollo
  .mutate({
    mutation: UPDATE_SURVEY_CORE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const sendSurveyProjectEmailInvitations = input => apollo
  .mutate({
    mutation: SEND_SURVEY_PROJECT_EMAIL_INVITE,
    variables: {
      input,
    },
    refetchQueries: ['surveyProjectDetailQuery'],
  })
  .then(res => res.data);

const SEND_SURVEY_PROJECT_EMAIL_REMINDER = gql`
  mutation sendSurveyProjectEmailReminders($input: SurveyProjectGenericMutationInput!) {
    sendSurveyProjectEmailReminders(input: $input)
  }
`;

export const sendSurveyProjectEmailReminders = input => apollo
  .mutate({
    mutation: SEND_SURVEY_PROJECT_EMAIL_REMINDER,
    variables: {
      input,
    },
    refetchQueries: ['surveyProjectDetailQuery'],
  })
  .then(res => res.data);

const SEND_SURVEY_RESPONDENT_EMAIL_INVITE = gql`
  mutation inviteRespondentTakeSurvey($input: InviteRespondentTakeSurveyInput!) {
    inviteRespondentTakeSurvey(input: $input) {
      surveyRespondent {
        id
        status
        invitedAt
      }
    }
  }
`;

export const sendSurveyRespondentEmailInvite = input => apollo.mutate({
  mutation: SEND_SURVEY_RESPONDENT_EMAIL_INVITE,
  variables: {
    input,
  },
});

const SEND_SURVEY_RESPONDENT_EMAIL_REMIND = gql`
  mutation remindRespondentTakeSurvey($input: RemindRespondentTakeSurveyInput!) {
    remindRespondentTakeSurvey(input: $input) {
      surveyRespondent {
        id
        status
      }
    }
  }
`;

export const sendSurveyRespondentEmailRemind = input => apollo.mutate({
  mutation: SEND_SURVEY_RESPONDENT_EMAIL_REMIND,
  variables: {
    input,
  },
});

const CREATE_SURVEY = gql`
  mutation($input: CreateSurveyInput!) {
    createSurvey(input: $input) {
      survey {
        id
      }
    }
  }
`;

export const createSurvey = input => apollo
  .mutate({
    mutation: CREATE_SURVEY,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const GET_SURVEY_URL = gql`
  query($surveyRespondentId: ID!, $accountId: ID!) {
    getSurveyUrl(surveyRespondentId: $surveyRespondentId, accountId: $accountId)
  }
`;

export const previewSurvey = ({ accountId, surveyRespondentId }) => apollo
  .query({
    query: GET_SURVEY_URL,
    variables: {
      surveyRespondentId,
      accountId,
    },
  })
  .then(res => res.data);

export const EDIT_RESPONDENT_MUTATE = gql`
mutation ChangeSurveyRespondents($input: UpdateSurveyRespondentsInput!) {
  updateSurveyRespondents(input: $input) {
    survey {
      id
      statuses
      managers {
        ...surveyRespondent
      }
      peers {
        ...surveyRespondent
      }
      directReports {
        ...surveyRespondent
      }
      others {
        ...surveyRespondent
      }
    }
  }
}

fragment surveyRespondent on SurveyRespondent {
  respondent {
    id
    firstName
    lastName
    email
  }
  startUrl
  previewInviteUrl
  previewReminderUrl
  id
  status
}
`;

export const updateSurveyRespondent = input => apollo
  .mutate({
    mutation: EDIT_RESPONDENT_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const INVITE_ALL = gql`
  mutation($input: InviteRespondentsTakeSurveyInput!) {
    inviteRespondentsTakeSurvey(input: $input) {
      survey {
        id
        statuses
        self {
          id
          status
        }
        managers {
          id
          status
        }
        peers {
          id
          status
        }
        directReports {
          id
          status
        }
        others {
          id
          status
        }
      }
    }
  }
`;

export const inviteAllRespondentsTakeSurvey = input => apollo
  .mutate({
    mutation: INVITE_ALL,
    variables: {
      input,
    },
  })
  .then(res => res.data);

export const SEND_REMINDER_TO_ALL = gql`
  mutation($input: RemindRespondentsTakeSurveyInput!) {
    remindRespondentsTakeSurvey(input: $input) {
      survey {
        id
        statuses
        self {
          id
          status
        }
        managers {
          id
          status
        }
        peers {
          id
          status
        }
        directReports {
          id
          status
        }
        others {
          id
          status
        }
      }
    }
  }
`;

export const remindsAllRespondentsTakeSurvey = input => apollo
  .mutate({
    mutation: SEND_REMINDER_TO_ALL,
    variables: {
      input,
    },
  })
  .then(res => res.data);
